import { render, staticRenderFns } from "./SelectButtons.vue?vue&type=template&id=5964abce"
import script from "./SelectButtons.vue?vue&type=script&lang=js"
export * from "./SelectButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports